<template>
    <div>
        <vxe-form>
            <vxe-form-item>
                <template v-slot>
                    <vxe-input v-model="searchVal" :placeholder="$t('message.placeholder.search')"
                        @keyup.enter.native="searchClick" :disabled='advancedSearch'></vxe-input>
                </template>
            </vxe-form-item>
            <vxe-form-item>
                <template v-slot>
                    <div style="display:flex;">
                        <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">{{
                            $t("message.button.search") }}</el-button>
                        <el-button type="primary" icon="el-icon-document-add" size="small" @click="createNewChange">{{
                            $t("message.button.create") }}</el-button>
                    </div>
                </template>
            </vxe-form-item>
        </vxe-form>

        <div v-loading="tableloading" v-if="!advancedSearch">
            <vxe-grid ref="xGrid" v-bind="addTableList" @cell-dblclick="dbClick">
                <template #quantityEdit="{ row }">
                    <vxe-input v-model="row.quantity"></vxe-input>
                </template>
                <template #departmentShow="{ row }">
                    <span>{{ formatDepartment(row.department) }}</span>
                </template>
                <template #departmentEdit="{ row }">
                    <vxe-select v-model="row.department" multiple clearable>
                        <vxe-option v-for="item in departmentList" :key="item.value" :value="item.value"
                            :label="item.label"></vxe-option>
                    </vxe-select>
                </template>
                <template v-slot:toolbar>
                    <vxe-toolbar custom>
                        <template v-slot:buttons> </template>
                    </vxe-toolbar>
                </template>
            </vxe-grid>
        </div>

        <el-pagination class="pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">s
        </el-pagination>

        <el-dialog v-if="creatNew" :visible.sync="creatNew" :close-on-click-modal="!creatNew" append-to-body>
            <Create :baseClass="baseClass_" :classIdAndSubClassId="classIdAndSubClassId" @addToAffectedItem="addToAffectedItem"
                @closeCreateNew="closeCreateNew">
            </Create>
        </el-dialog>

    </div>
</template>
<script>
import axios from "axios";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
import Create from "@/components/common/Create.vue";
export default {
    name: "searchAdd",
    data() {
        return {
            noPendingItem: true,
            advancedSearch: false,
            searchVal: "",
            rols_text: [],
            tableShow: false,
            rols_text: [],
            cols: [],
            pageSizes: [100, 200, 500, 1000],
            pageSize: 100,
            currentPage: 1,
            totalRecords: 0,
            paginationShow: false,
            loading: false,
            tableToolbar: {
                buttons: [{ code: "myInsert", name: "", type: "text" }],
                custom: true,
                slots: {
                    tools: "tools",
                },
            },
            TagList: [],
            linkProperty: '',
            ll: [
                "el-icon-news",
                "el-icon-data-line",
                "el-icon-office-building",
                "el-icon-paperclip",
            ],
            colorList: ["#13ce66", "#fcad2c", "#F56C6C", "#38A8F6"],
            iconType: [],
            addTableList: {
                keepSource: true,
                resizable: true,
                border: true,
                stripe: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                rowId: "id",
                height: "530",
                size: "small",
                columns: [],
                data: [],

                editConfig: {
                    trigger: "dblclick",
                    mode: "cell",
                    activeMethod: this.activeRowMethod,
                    showStatus: true,
                },
                sortConfig: {
                    trigger: "cell",
                },
            },
            tableloading: false,
            checkedSubMaterials: false,
            messageData: "NO",
            options: [],
            value: '',
            creatNew: false,
            baseClass_: "104",
            classIdAndSubClassId: [],
            copyChangeInfo: {}
        };
    },
    mounted() { },
    components: {
        SearchQuery,
        Create
    },
    props: ['copyAffectedItems', 'departmentList'],
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.searchClick();

        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.searchClick();
        },
        activeRowMethod(row) {
            if (row.column.field === "quantity" || row.column.field === "department") {
                return true;
            }
        },
        formatDepartment(e) {
            if (e) {
                return e.map(i => this.departmentList.find(j => j.value == i).label).join(',')
            }
            return ''
        },
        searchClick() {
            this.tableloading = true;
            var obj_get = {
                baseClassId: 104,
                value: this.searchVal,
                size: this.pageSize,
                page: this.currentPage,
                byImport: "byImport"
            };
            axios.get(`/pmdm/search/simple${this.params(obj_get)}`)
                .then(res => {
                    if (res.data.code == 200) {
                        const { table } = res.data.object;
                        this.totalRecords = table.totalRecords;
                        this.formatTable(table);
                    }
                });
        },
        formatTable(data) {
            if (!this.totalRecords) {
                this.$message({
                    message: this.$t("message.warning.searchErr_02"),
                    type: "warning",
                });
                this.addTableList.data = [];
                this.tableloading = false;
                return;
            }
            this.paginationShow = true;
            let items = data.columnInfo.names;
            let rows = data.rows;
            let typeFilter = [...new Set(rows.map(i => i.cells[2].val))].map(j => ({ 'label': j, 'value': j }));
            let lcpFilter = [...new Set(rows.map(i => i.cells[3].val))].map(j => ({ 'label': j, 'value': j }));
            this.cols = items.map((i, e) => ({ field: e, title: items[e] }));
            this.cols.find(i => i.field == 2).filters = typeFilter;
            this.cols.find(i => i.field == 3).filters = lcpFilter;
            this.addTableList.columns = [...this.cols];
            this.addTableList.data = rows.map(i => {
                let el = {};
                i.cells.map((j, e) => { el[e] = j.val });
                el.itemNumber = i.cells[0].val;
                el.quantity = '';
                el.id = i.objId;
                el.authTag = i.authTag;
                el.subClassId = i.objSubClass;
                el.classId = i.objClass;
                return el;
            })
            this.tableloading = false;
        },
        dbClick(params) {
            let changeObjId = {
                classId: params.row.classId,
                id: params.row.id,
                subClassId: params.row.subClassId,
                version: 0
            };
            let insertAffectedItem = this.copyAffectedItems.map(i => ({
                changeId: params.row.id,
                item: i.itemId,
                itemNumber: i[0]
            }));
            let obj = {
                changeObjId: changeObjId,
                insertAffectedItem: insertAffectedItem,
                isAdd: "1",
                tableId: 5
            };
            this.copyChangeInfo = {
                classId: params.row.classId,
                id: params.row.id,
                name: params.row[0],
                subClassId: params.row.subClassId
            };
            this.saveTable(obj);
        },
        async saveTable(obj) {
            try {
                const res = await axios.post("/pmdm/changes/saveTable", obj);
                if (res.data.code == 200) {
                    const { errList = [] } = res.data.object;
                    if (errList.length) {
                        let str = '';
                        errList.forEach(i => {
                            str += `<p>${i}</p>`
                        });
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: str,
                            type: "warning",
                        });
                        return
                    } else {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: res.data.message,
                            type: "success",
                        });
                        this.getLink(this.copyChangeInfo);
                    }
                } else {
                    throw new Error('Unexpected response code');
                }
            } catch (error) {
                console.error('Error saving table:', error);
            }
        },
        createNewChange() {
            let objectId = this.$store.state.objectId;
            this.classIdAndSubClassId = [objectId.classId, objectId.subClassId];
            this.creatNew = true;
        },
        closeCreateNew() {
            this.creatNew = false;
        },
        async addToAffectedItem(e) {
            let data = e[0];
            let changeObjId = {
                classId: data.itemClass,
                id: data.id,
                subClassId: data.itemSubClassId,
                version: 0
            };
            let insertAffectedItem = this.copyAffectedItems.map(i => ({
                changeId: data.id,
                item: i.itemId,
                itemNumber: i[0]
            }));
            let obj = {
                changeObjId: changeObjId,
                insertAffectedItem: insertAffectedItem,
                isAdd: "1",
                tableId: 5
            };
            const result = await axios.post("/pmdm/changes/saveTable", obj);
            if (result.data.code == 200) {
                let item = {
                    classId: e[0].itemClass,
                    id: e[0].itemId,
                    name: e[0].itemNumber,
                    subClassId: e[0].itemSubClassId
                };
                this.closeCreateNew();
                this.getLink(item);
            }
        }
    }
};
</script>
<style scoped>
.pagination {
    margin-top: 15px;
    text-align: left;
}
</style>